import { Component, Input } from '@angular/core';
import { ScansInterface } from '@monsido/modules/models/api/interfaces/scans.interface';

@Component({
    selector: 'mon-request-checker-redirect-component',
    templateUrl: 'redirect.html',
    styleUrls: ['./../../request-checker.scss'],
    standalone: false,
})

export class RedirectComponent {
    @Input() url: string;
    @Input() scan: ScansInterface;
    constructor () {}
}
